import React from 'react';
import { useGetLoadingState } from 'src/redux/loading/loadingSlice';
import './style.scoped.css';

export interface LoadingModalRef {
  open: () => void;
  close: () => void;
}
const LoadingModal = (props) => {
  const { isLoading } = useGetLoadingState();

  if (isLoading)
    return (
      <div className="popupModal">
        <div className="loading-spinner-rolling">
          <div className="loading">
            <div></div>
          </div>
        </div>
      </div>
    );
  return <div />;
};

export default LoadingModal;
